import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormArray, FormGroup } from '@angular/forms';
import { Port } from 'src/app/models/Port';
import { PortService } from 'src/app/core-services/port.service';
import { ToastrService } from 'ngx-toastr';
import { VoyageService } from '../../services/voyage.service';
import { DefaultPort, DefaultPortVoyagePerformance } from 'src/app/Enum/Enum';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';

@Component({
  selector: 'app-voyage-performance',
  templateUrl: './voyage-performance.component.html',
  styleUrls: ['./voyage-performance.component.scss']
})
export class VoyagePerformanceComponent implements OnInit {
  dataSource: Object;
  portsData: Port[] = [];
  currentDate: Date;
  currentYear: number;
  yearsDataList: any[] = [];
  submitted: boolean = false;
  noOfVessels: any;
  frequencyData: any;
  noOfPortCalls: any;
  voyageLength: any;
  companyName: string[] = [];
  companydata: number[] = [];
  shippingLineId: number[] = [];
  fromPortId: number;
  toPortId: number;
  searchDate: string = '';
  isFirstTime: boolean = true;
  options: any;
  voyageform: FormGroup;
  mothData: any[] = [];
  selectedShipId:number;

  constructor(private fb: FormBuilder, private portService: PortService, private toastr: ToastrService,
    private voyageService: VoyageService, private spinner: NgxSpinnerService, private router: Router) { }


  ngOnInit() {
    this.voyageform = this.fb.group({
      fromPort: ["", Validators.required],
      toPort: ["", Validators.required],
      month: [""],
      year: ["", Validators.required]
    });

    this.currentDate = new Date();
    this.currentYear = this.currentDate.getUTCFullYear();
    for (let year = this.currentYear; year <= this.currentYear + 50; year++) {
      if (year != null) {
        var yearData =
        {
          value: year,
          viewValue: year,
        };
        this.yearsDataList.push(yearData);
      }
    }
    this.getMonthLookUpData();
    this.getPortDatafordropdown();

    this.fromPortId = DefaultPortVoyagePerformance.Bremerhaven;
    this.toPortId = DefaultPortVoyagePerformance.Singapore;
    this.searchDate = this.currentDate.getUTCFullYear().toString();
    var defaultYear = {
      value: this.currentYear,
      viewValue: this.currentYear
    }
    this.voyageform.controls.year.setValue(defaultYear);
    this.getVoyagePerformance();

  }
  getPortDatafordropdown() {
    this.portService.GetPortData().subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.portsData = response.content;
        if (this.isFirstTime == true) {
          var fromPort = response.content.filter(x => x.id == DefaultPortVoyagePerformance.Bremerhaven);
          var toPort = response.content.filter(x => x.id == DefaultPortVoyagePerformance.Singapore);
          if (fromPort != null && fromPort.length > 0) {
            this.fromPortId = fromPort[0].id;
            this.voyageform.controls.fromPort.setValue(fromPort[0]);
          }
          if (toPort != null && toPort.length > 0) {
            this.toPortId = toPort[0].id;
            this.voyageform.controls.toPort.setValue(toPort[0]);
          }
          this.isFirstTime = false;
          // this.getVoyagePerformance();
        }
      }
    });
  }

  getMonthLookUpData() {
    this.voyageService.getMasterLookUpMonth().subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.mothData = response.content;
      }
    });
  }
  searchPorts(event, flag) {
    let portName = '';
    if (event != null && event.query != null && event.query != '') {
      if (event.query.length > 2) {
        portName = event.query;
      }
      else {
        this.portsData = [];
      }
    }
    else {
      if (flag == 'from') {
        if (this.voyageform.controls.fromPort.value != null && this.voyageform.controls.fromPort.value != '') {
          portName = this.voyageform.controls.fromPort.value.portName;
        }
      }
      else {
        if (this.voyageform.controls.toPort.value != null && this.voyageform.controls.toPort.value != '') {
          portName = this.voyageform.controls.toPort.value.portName;
        }
      }
    }
    if (event.query != '') {
      var data = {
        PortName: portName
      };
      this.portService.GetPortDataByName(data).subscribe((response: any) => {
        if (response != null && response.content != null) {
          this.portsData = response.content;
        }
        else {
          this.portsData = [];
        }
      })
    }
    else {
      this.getPortDatafordropdown();

    }
  }

  onSearch() {
    this.submitted = true;
    if (this.voyageform.invalid) {
      this.toastr.error("InValid Form, Please select Region and Year.", "Error");
      return;
    }
    else {
      var data = this.voyageform.value;
      if (data != null && (data.fromPort != null && data.fromPort != '') && (data.toPort != null && data.toPort != '') && (data.year != null && data.year != '')) {
        if (data.month != null && data.month != '' && data.month.id > 0) {
          if (data.month.id < 10) {
            this.searchDate = data.year.value + '-' + '0' + data.month.id
          }
          else {
            this.searchDate = data.year.value + '-' + data.month.id
          }

        }
        else {
          if (data.year.value > 0) {
            this.searchDate = data.year.value.toString();
          }

        }

        if (data.fromPort.id > 0 && data.toPort.id > 0) {
          if (data.fromPort.id != data.toPort.id) {
            this.fromPortId = data.fromPort.id;
            this.toPortId = data.toPort.id;
            this.getVoyagePerformance();
          }
          else {
            this.toastr.error("Port should be different.", "Error");
          }
        }
        else {
          this.toastr.error('Incurrect port', 'Erro');
        }
      }
    }
  }

  getVoyagePerformance() {
    if (this.fromPortId > 0 && this.toPortId > 0 && this.searchDate != null && this.searchDate != '') {
      var voyageData = {
        fromPortId: this.fromPortId,
        toPortId: this.toPortId,
        searchDate: this.searchDate
      }
      this.spinner.show();
      this.voyageService.getVoyagePerformance(voyageData).subscribe((response: any) => {
        if (response != null && response.content != null) {
          this.spinner.hide();
          // bind No of Vessels chart
          if (response.content.noOfVesselsWithShips) {
            let res = response.content;
            this.noOfVessels = [];
            this.companyName = [];
            this.companydata = [];
            this.shippingLineId = [];
            response.content.noOfVesselsWithShips.forEach(element => {
              if (element != null && element.companyName != null && element.companyName != '') {
                if (element.companyName == 'Wallenius Wilhelmsen Ocean') {
                  element.companyName = 'WWO'
                }
                this.companyName.push(element.companyName);
                this.companydata.push(element.noOfVessels);
                this.shippingLineId.push(element.id);
              }
            });

            this.noOfVessels = {
              labels: this.companyName,
              datasets: [
                {
                  lablesfortip: this.companyName,
                  shipId: this.shippingLineId,
                  label: 'No Of Vessels',
                  backgroundColor: '#6DCFD1',
                  borderColor: '#1E88E5',
                  data: this.companydata,
                }
              ],
            }
          }
          // bind Frequency of shippiingline
          if (response.content.frequencyOfWithShips) {
            let res = response.content.frequencyOfWithShips;
            this.frequencyData = [];
            this.companyName = [];
            this.companydata = [];
            this.shippingLineId = [];
            response.content.frequencyOfWithShips.forEach(element => {
              if (element != null && element.companyName != null && element.companyName != '') {
                if (element.companyName == 'Wallenius Wilhelmsen Ocean') {
                  element.companyName = 'WWO'
                }
                this.companyName.push(element.companyName);
                this.companydata.push(element.noOfAVGDays);
                this.shippingLineId.push(element.id);
              }
            });

            this.frequencyData = {
              labels: this.companyName,
              datasets: [
                {
                  lablesfortip: this.companyName,
                  shipId: this.shippingLineId,
                  label: 'Frequency(days betwen sailings)',
                  backgroundColor: '#6DCFD1',
                  borderColor: '#1E88E5',
                  data: this.companydata,
                }
              ],
            }
          }
          // bind No Of port call
          if (response.content.noOfPortCallsWithShips) {
            let res = response.content.noOfPortCallsWithShips;
            this.noOfPortCalls = [];
            this.companyName = [];
            this.companydata = [];
            this.shippingLineId = [];
            response.content.noOfPortCallsWithShips.forEach(element => {
              if (element != null && element.companyName != null && element.companyName != '') {
                if (element.companyName == 'Wallenius Wilhelmsen Ocean') {
                  element.companyName = 'WWO'
                }
                this.companyName.push(element.companyName);
                this.companydata.push(element.noOfPortCall);
                this.shippingLineId.push(element.id);
              }
            });

            this.noOfPortCalls = {
              labels: this.companyName,
              datasets: [
                {
                  lablesfortip: this.companyName,
                  shipId: this.shippingLineId,
                  label: 'No of ports call in voyage',
                  backgroundColor: '#6DCFD1',
                  borderColor: '#1E88E5',
                  data: this.companydata,
                }
              ],
            }
          }
          // Bind Voyage Length
          if (response.content.voyageLengthWithShips) {
            let res = response.content.voyageLengthWithShips;
            this.voyageLength = [];
            this.companyName = [];
            this.companydata = [];
            this.shippingLineId = [];
            response.content.voyageLengthWithShips.forEach(element => {
              if (element != null && element.companyName != null && element.companyName != '') {
                if (element.companyName == 'Wallenius Wilhelmsen Ocean') {
                  element.companyName = 'WWO'
                }
                this.companyName.push(element.companyName);
                this.companydata.push(element.noOfAVGDays);
                this.shippingLineId.push(element.id);
              }
            });

            this.voyageLength = {
              labels: this.companyName,
              datasets: [
                {
                  lablesfortip: this.companyName,
                  shipId: this.shippingLineId,
                  label: 'Voyage length in days',
                  backgroundColor: '#6DCFD1',
                  borderColor: '#1E88E5',
                  data: this.companydata,
                }
              ],
            }
          }
          this.options = {
            title: {
              display: true,
              //text: 'My Title',
              fontSize: 16
            },
            legend: {
              position: 'bottom'
            }
          };
        }
         this.spinner.hide();
      });
    }
  }
  selectDataOfChart(event) {
    if (event != null && event.element != null && event.element._chart != null && event.element._chart.data != null) {
      if (event.element._chart.data.datasets.length > 0 && event.element._chart.data.datasets[0].shipId != null && event.element._chart.data.datasets[0].shipId.length > 0) {
        if(event.element._index != null && event.element._index >= 0)
        {
            this.selectedShipId = event.element._chart.data.datasets[0].shipId[event.element._index]
            if(this.selectedShipId > 0)
            {
              let url = '/voyageperformance/' + this.selectedShipId + '/' + this.fromPortId + '/' + this.toPortId + '/' + this.searchDate
              this.router.navigate([url]);
            }
        }
      }
    }
    var data = event;
  }
}
